/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import FormFader from "../Common/Fader/FormFader";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import FormSubmit from "../Common/FormSubmit/FormSubmit";
import CheckIcon from "../../../assets/icons/common/toggleable/IconCheck";
import CrossIcon from "../../../assets/icons/common/toggleable/IconClose";
import Hidden from "@mui/material/Hidden";
import { Box, MenuItem } from "@mui/material";
import { useForm } from "../../../provider/Form/FormProvider";
import Group from "../../Wizard/Group";
import { requiredValidator } from "../../../services/validationRules";
import ValidatorSelectField from "../../FormFields/ValidatorSelectField";
import Typography from "@mui/material/Typography";
import NumberFieldConfigured from "../ConfiguredFormElements/NumberFieldConfigured/NumberFieldConfigured";
import FormSubmitProps from "../../../types/FormSubmitProps";
import wizardStyle from "../wizardStyle";

type MobilityCostDeductionProps = {
  submitProps: FormSubmitProps;
};

export default function MobilityCostDeduction({ submitProps }: MobilityCostDeductionProps) {
  const { values, handleSubmit } = useForm();
  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <FormFader>
        <Box component={"form"} sx={wizardStyle.wizardForm} onSubmit={handleSubmit}>
          <Hidden smUp>
            <Typography variant={"h4"} sx={wizardStyle.headline}>
              Ausgaben
            </Typography>
          </Hidden>
          <Grid container justifyContent={"center"}>
            <Grid item xs={12}>
              <Group
                type={"radio"}
                name={"hasMobilityCostDeduction"}
                question={"Haben Sie Fahrtkosten für den Weg zur Arbeit?"}
                modalContent={<p>Unter die Fahrtkosten fallen zum Beispiel Kosten für den öffentlichen Nahverkehr oder Fahrten mit dem privaten PKW.</p>}
                options={[
                  {
                    labelText: "Nein",
                    labelIcon: <CrossIcon />,
                    labelIconActive: <CrossIcon active />,
                    value: "no",
                  },
                  {
                    labelText: "Ja",
                    labelIcon: <CheckIcon />,
                    labelIconActive: <CheckIcon active />,
                    value: "yes",
                  },
                ]}
                validators={[requiredValidator("Bitte wählen Sie eine der angezeigten Antworten aus")]}
              />
            </Grid>
            {values.hasMobilityCostDeduction === "yes" && (
              <>
                <Grid item xs={12}>
                  <ValidatorSelectField
                    label={"Verkehrsmittel"}
                    name={`mobilityCostUnit`}
                    validators={[requiredValidator("Bitte geben Sie das Verkehrsmittel an")]}
                    MenuProps={{ PaperProps: { style: { maxHeight: 200 } } }}
                  >
                    <MenuItem value={"km"}>Mit dem eigenen Auto</MenuItem>
                    <MenuItem value={"€"}>Mit öffentlichen Verkehrsmitteln</MenuItem>
                  </ValidatorSelectField>
                </Grid>
                {values.mobilityCostUnit && (
                  <NumberFieldConfigured
                    caseData={values}
                    fieldPath={"mobilityCostAmount"}
                    fieldType={values.mobilityCostUnit === "km" ? null : "money"}
                    numberType={"float"}
                    required
                  />
                )}
              </>
            )}
          </Grid>
          <FormSubmit {...submitProps} />
        </Box>
      </FormFader>
    </Paper>
  );
}
